import apiService from '@/lib/api-service'

export default {
  install (Vue) {
    Object.defineProperty(Vue.prototype, '$api', {
      value: apiService
    })
  }
}
